import { render, staticRenderFns } from "./BookRepair.vue?vue&type=template&id=6baac4ad&"
import script from "./BookRepair.vue?vue&type=script&lang=js&"
export * from "./BookRepair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports